/**
 * Sentry `ignoreErrors`: errors thrown by code that is not ours and that we cannot fix.
 *
 * Keep each entry to one exact message, never a broad pattern, and say where it comes from. A
 * pattern that also matches our own code hides a real bug for good. Sentry tests a pattern against
 * the error's message and against `Type: message`.
 */
export const SENTRY_IGNORE_ERRORS: RegExp[] = [
  // Facebook's and Instagram's iOS in-app browser inject a script that talks to the native app
  // through `window.webkit.messageHandlers`, and it throws where that bridge is missing. Comes with
  // `hxp-chat-suppression` / "IAB unified bridge" console lines, from visitors arriving on an
  // `fbclid` link. Nothing in the repo uses `window.webkit`.
  /undefined is not an object \(evaluating 'window\.webkit\.messageHandlers/,
]
